import { SUPPORTED_LANGS } from '../../../constants/languages';
import { CITY_SLUGS, getCityDbKey } from '../../../constants/cityMeta';

const KNOWN_CITY_SLUGS = new Set(CITY_SLUGS);

const KA_CITY_LOC = {
    tbilisi: 'თბილისში',
    batumi: 'ბათუმში',
    kutaisi: 'ქუთაისში',
    rustavi: 'რუსთავში',
    gori: 'გორში',
    zugdidi: 'ზუგდიდში',
    poti: 'ფოთში',
    telavi: 'თელავში',
    kobuleti: 'ქობულეთში',
    mtskheta: 'მცხეთაში',
    borjomi: 'ბორჯომში',
    bolnisi: 'ბოლნისში',
    marneuli: 'მარნეულში',
    gurjaani: 'გურჯაანში',
    akhaltsikhe: 'ახალციხეში',
};

const RU_CITY_LOC = {
    tbilisi: 'Тбилиси',
    batumi: 'Батуми',
    kutaisi: 'Кутаиси',
    rustavi: 'Рустави',
    gori: 'Гори',
    zugdidi: 'Зугдиди',
    poti: 'Поти',
    telavi: 'Телави',
    kobuleti: 'Кобулети',
    mtskheta: 'Мцхета',
    borjomi: 'Боржоми',
    bolnisi: 'Болниси',
    marneuli: 'Марнеули',
    gurjaani: 'Гурджаани',
    akhaltsikhe: 'Ахалцихе',
    akhmeta: 'Ахмета',
    sighnaghi: 'Сигнаги',
    khashuri: 'Хашури',
    chiatura: 'Чиатура',
};

const EN_CITY_LOC = {
    tbilisi: 'Tbilisi',
    batumi: 'Batumi',
    kutaisi: 'Kutaisi',
    rustavi: 'Rustavi',
    gori: 'Gori',
    zugdidi: 'Zugdidi',
    poti: 'Poti',
    telavi: 'Telavi',
    kobuleti: 'Kobuleti',
    mtskheta: 'Mtskheta',
    borjomi: 'Borjomi',
    bolnisi: 'Bolnisi',
    marneuli: 'Marneuli',
    gurjaani: 'Gurjaani',
    akhaltsikhe: 'Akhaltsikhe',
    akhmeta: 'Akhmeta',
    sighnaghi: 'Sighnaghi',
    khashuri: 'Khashuri',
    chiatura: 'Chiatura',
    oni: 'Oni',
};

const UA_CITY_LOC = {
    tbilisi: 'Тбілісі',
    batumi: 'Батумі',
    kutaisi: 'Кутаїсі',
    rustavi: 'Руставі',
    gori: 'Горі',
    zugdidi: 'Зугдіді',
    poti: 'Поті',
    telavi: 'Телаві',
    kobuleti: 'Кобулеті',
    mtskheta: 'Мцхета',
    borjomi: 'Боржомі',
    marneuli: 'Марнеулі',
    gurjaani: 'Гурджаані',
};

const CITY_LOC_BY_LANG = {
    ge: KA_CITY_LOC,
    ru: RU_CITY_LOC,
    en: EN_CITY_LOC,
    ua: UA_CITY_LOC,
};

function titleCaseBrand(slug) {
    if (!slug) return '';
    return slug
        .split('-')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join('-');
}

function removeAllLanguagePrefixes(pathname) {
    if (!pathname || pathname === '/') return '/';
    let cleanPath = pathname;
    while (true) {
        const match = cleanPath.match(/^\/([a-z]{2})(\/|$)/);
        if (match && SUPPORTED_LANGS.includes(match[1])) {
            cleanPath = cleanPath.substring(3);
            if (!cleanPath) return '/';
            if (!cleanPath.startsWith('/')) cleanPath = `/${cleanPath}`;
        } else {
            break;
        }
    }
    return cleanPath || '/';
}

export function extractUrlContext(pathname) {
    const cleanPath = removeAllLanguagePrefixes(pathname);
    const parts = cleanPath.split('/').filter(Boolean);
    const ctx = { citySlug: null, brandSlug: null, modelSlug: null };

    if (parts[0] !== 'search') return ctx;

    let cursor = 2;
    if (parts[1] === 'rent' || parts[1] === 'parts') cursor = 3;

    while (cursor < parts.length) {
        const seg = parts[cursor];
        if (seg === 'brand' && parts[cursor + 1]) {
            ctx.brandSlug = parts[cursor + 1];
            if (parts[cursor + 2] && !KNOWN_CITY_SLUGS.has(parts[cursor + 2])) {
                ctx.modelSlug = parts[cursor + 2];
                cursor += 3;
            } else {
                cursor += 2;
            }
            continue;
        }
        if (KNOWN_CITY_SLUGS.has(seg)) {
            ctx.citySlug = seg;
        }
        cursor += 1;
    }

    return ctx;
}

export function getCityDisplayName(citySlug, lang, t) {
    if (!citySlug) return '';
    const locMap = CITY_LOC_BY_LANG[lang] || EN_CITY_LOC;
    if (locMap[citySlug]) return locMap[citySlug];
    if (t) {
        const tKey = getCityDbKey(citySlug);
        const translated = t(tKey);
        if (translated && translated !== tKey) return translated;
    }
    return citySlug.charAt(0).toUpperCase() + citySlug.slice(1);
}

export function getBrandDisplayName(brandSlug) {
    return titleCaseBrand(brandSlug);
}

export function getModelDisplayName(modelSlug) {
    return titleCaseBrand(modelSlug);
}
